module.exports = __webpack_public_path__ + "fonts/glyphicons-halflings-regular.68ed1dac.woff";